import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import Contact from "../pages/contact/page";
import CaseStudies from "../pages/case-studies/page";



const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/case-studies",
    element: <CaseStudies />,
  },
  {
    path: "/offerings",
    element: <Navigate to="/services" replace />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },  
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;